import { EventDrivenStore } from '@core/store/eventDrivenStore';
import constants from '@core/utils/constants';

class ServicesStore extends EventDrivenStore {
  constructor() {
    const initialState = {
      transactionInitiation: {},
      initiatingPayment: false,
      initiationErrorTitle: null,
      initiationError: null,
      paymentInitiated: false,
      wavePaymentLink: null,
      wavePaymentLinkPolling: false,
      wavePaymentLinkTimeout: false,
      phoneUpdate: {
        isUpdating: false,
        newPhoneNumber: null,
        paymentStatus: 'idle', // idle, pending, success, failed
        paymentError: null,
        requestId: null
      }
    };
    super('services', initialState, {
      useLocalStorage: true
    });
    if (!this.state.phoneUpdate) {
      this.state.phoneUpdate = { ...initialState.phoneUpdate };
    }
  }

  async setupEvents() {
    this.on(constants.EVENTS.SERVICES.OPTIONS.SELECT, (service) => {
      this.state.transactionInitiation.service = service;
      this.state.transactionInitiation.bookmakerId = '';
      this.state.initiatingPayment = false;
      this.state.paymentInitiated = false;
      this.state.initiationErrorTitle = null;
      this.state.initiationError = null;
      this.state.transactionInitiation.otp = '';
      this.state.transactionInitiation.isWave = false;
      this.state.transactionInitiation.isConfirming = false;
    });
    this.on(constants.EVENTS.SERVICES.OPTIONS.SELECTED, (operation) => {
      this.state.transactionInitiation.service =
        constants.SERVICES.SERVICES_LIST.find(
          (service) => service.id == operation.serviceId
        );
      this.state.transactionInitiation.operation = operation;
      this.state.transactionInitiation.otpCode = '';
      this.state.transactionInitiation.bookmakerId = '';
      this.state.transactionInitiation.paymentMethod = {
        id: 'mobileMoney',
        name: 'Mobile Money'
      };
      this.state.transactionInitiation.recipientMethod = {
        id: 'mobileMoney',
        name: 'Mobile Money'
      };
      this.state.initiatingPayment = false;
      this.state.paymentInitiated = false;
      this.state.initiationErrorTitle = null;
      this.state.initiationError = null;
      this.state.transactionInitiation.otp = '';
      this.state.transactionInitiation.isWave = false;
      this.state.transactionInitiation.isConfirming = false;
    });
    this.on(constants.EVENTS.SERVICES.INITIATION.CONFIRM, () => {
      this.state.initiatingPayment = true;
      this.state.paymentInitiated = false;
      this.state.initiationErrorTitle = null;
      this.state.initiationError = null;
    });
    this.on(constants.EVENTS.SERVICES.INITIATION.SUBMIT_FORM, () => {
      this.state.initiatingPayment = false;
      this.state.paymentInitiated = false;
      this.state.initiationErrorTitle = null;
      this.state.initiationError = null;
    });
    this.on(constants.EVENTS.SERVICES.INITIATION.INITIATION_FAILED, (error) => {
      this.state.initiatingPayment = false;
      this.state.paymentInitiated = false;
      this.state.initiationErrorTitle =
        error?.messageTitle || 'Une erreur est survenue';
      this.state.initiationError = error?.message || error;
    });
    this.on(constants.EVENTS.SERVICES.INITIATION.INITIATED, () => {
      this.state.initiatingPayment = false;
      this.state.paymentInitiated = true;
      this.state.initiationErrorTitle = null;
      this.state.initiationError = null;
      this.state.wavePaymentLink = null;
      this.state.wavePaymentLinkPolling = false;
      this.state.wavePaymentLinkTimeout = false;
    });
    this.on(constants.EVENTS.SERVICES.INITIATION.WAVE_PAYMENT_LINK_POLLING_START, () => {
      this.state.wavePaymentLink = null;
      this.state.wavePaymentLinkPolling = true;
      this.state.wavePaymentLinkTimeout = false;
    });
    this.on(constants.EVENTS.SERVICES.INITIATION.WAVE_PAYMENT_LINK_FOUND, ({ paymentLink }) => {
      this.state.wavePaymentLink = paymentLink;
      this.state.wavePaymentLinkPolling = false;
      this.state.wavePaymentLinkTimeout = false;
    });
    this.on(constants.EVENTS.SERVICES.INITIATION.WAVE_PAYMENT_LINK_TIMEOUT, () => {
      this.state.wavePaymentLinkPolling = false;
      this.state.wavePaymentLinkTimeout = true;
    });
    this.on(constants.EVENTS.BOOKMAKER.BOOKMAKER_ID_CONFIRMED, (data) => {
      const { bookmakerId, bookmaker } = data;
      if (bookmaker !== this.state.transactionInitiation.service?.id) return;
      this.state.transactionInitiation.bookmakerIdToUse = bookmakerId;
    });

    // Phone Update events
    this.on(constants.EVENTS.SERVICES.PHONE_UPDATE.START, () => {
      this.state.phoneUpdate.isUpdating = true;
      this.state.phoneUpdate.paymentStatus = 'idle';
      this.state.phoneUpdate.paymentError = null;
    });

    this.on(constants.EVENTS.SERVICES.CLOSE_OPERATION_INITIATION, () => {
      this.state.phoneUpdate.isUpdating = false;
      this.state.wavePaymentLinkPolling = false;
    });

    this.on(constants.EVENTS.SERVICES.PHONE_UPDATE.COMPLETED, (newPhone) => {
      this.state.phoneUpdate.isUpdating = false;
      this.state.transactionInitiation.phoneNumber = newPhone;
    });

    this.on(constants.EVENTS.SERVICES.CLOSE_SERVICE_INITIATION, () => {
      this.state.initiatingPayment = false;
      this.state.paymentInitiated = false;
      this.state.initiationErrorTitle = null;
      this.state.initiationError = null;
    });
  }
}

export default ServicesStore;
